export class BaseDefinitionDto {
  code: string;
  description?: string;
  groupName?: string;
  id?: number;
  name: string;
  status?: string;

  createdBy?: string;
  createdDate?: Date;
  updatedBy?: string;
  updatedDate?: Date;

  constructor(data?: BaseDefinitionDto) {
    Object.assign(this, data || {});
  }
}
